import { createContext, useContext, useEffect, useState } from 'react';
import { getCurrentUser, isAuthenticated, logout as apiLogout } from '@api/client';

const AuthContext = createContext({
  user: null,
  isAuthed: false,
  setUser: () => {},
  logout: () => {},
});

export function AuthProvider({ children }) {
  // Initialize from localStorage on first render
  const [user, setUser] = useState(() => getCurrentUser());

  // Listen for storage events from other tabs (logout in tab A → tab B sees it)
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === '1ayurved_token' && !e.newValue) {
        setUser(null);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const logout = () => {
    apiLogout();
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthed: isAuthenticated() && !!user,
        setUser,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}